import {newAuthorCss } from "../css/Main.style";
import {ReactComponent as MainNewAuthorBackground} from '../../../assets/Union.svg';
import {ReactComponent as MainNewAuthorBackgroundLeft} from '../../../assets/Union_left.svg';
import axios from "axios";
import {useEffect, useState} from "react";
import {useNavigate, Link} from "react-router-dom";

const NewAuthor = ({authors}: {authors: any}) => {

    const navigate = useNavigate();

    const moveToAuthorDetail = (author: any) => {
        navigate(`/author/authordetails/${author.authorId}`, {
            state: { authorEmail: author.authorEmail }
        });
    };



    const chunkedAuthors = [];
    if (Array.isArray(authors)) {
        for (let i = 0; i < authors.length; i += 2) {
            chunkedAuthors.push(authors.slice(i, i + 2));
        }
    }

    return(
        <div css={newAuthorCss}>
            <div className="MainNewAuthorBackground">
                <MainNewAuthorBackground/>
            </div>


            <div className="newAuthorWrap">
                <span className={" text-nowrap flex "}>방금 북밋에 등록한 작가를 만나 보세요!</span>

                {chunkedAuthors.map((authorPair: any, index: number) => (
                    <div className="area " key={index}>
                        {authorPair.map((author: any, authorIndex: any) => (
                             <Link to={`/author/authordetails/${author.authorId}`} state={{ authorEmail: author.authorEmail }} className="authorContent block cursor-pointer text-inherit no-underline" key={authorIndex} >
                                <div className="profile">
                                    <img
                                        src={author.profilePhoto ? `data:image/png;base64,${author.profilePhoto}` : "/img/profile_sample.jpg"} // author.profileImage로 변경
                                        alt="작가"
                                        className="object-cover"
                                    />
                                    <span className="name">
                                        {author.authorName}
                                    </span>
                                </div>

                                <div className="divide"></div>

                                <div className="authorText ">
                                    <span> {author.authorIntro?.length > 100
                                        ? `${author.authorIntro.slice(0, 100)}...`
                                        : author.authorIntro}</span>
                                </div>
                            </Link>
                        ))}
                    </div>
                ))}
            </div>
            <div className="MainNewAuthorBackgroundLeft">
                <MainNewAuthorBackgroundLeft/>
            </div>
        </div>
    )
}

export default NewAuthor;
